<template>
  <v-app id="app" class="app" :class="{'menu-open': menuOpen}" v-show="isReady" :style="{minHeight: `${viewPort.height}px`}">

    <transition name="scroll-x-transition" appear>
      <v-app-bar fixed flat :dark="dark">
        <v-row align="center" justify="start" >
          <v-col class="py-1 shrink text-no-wrap">
            <v-toolbar-title>
              <router-link v-if="!navigationDisabledInRoute" aria-label="Home" data-cursor-target="center center" :to="{name: 'Home', params: {language:$language.current}}"><Logo /></router-link>
              <Logo v-else />
            </v-toolbar-title>
          </v-col>
          <v-col class="caption py-1 text-truncate text-right" v-if="!navigationDisabledInRoute">
            <v-btn text icon :aria-label="menuOpen ? 'Close Menu' : 'Open Menu'" @click="menuOpen = !menuOpen; $root.soundManager.playClick()" class="hamburger" data-cursor-target="center center" >
              <lottie :options="{animationData: HamburgerAnim, loop: false}" :height="50" :width="50" @animCreated="handleAnimation"/>
              <!-- <transition mode="out-in">
                <HamburgerIcon key="hamburger" v-if="!menuOpen"/>
                <CloseIcon key="close" v-else/>
              </transition> -->
            </v-btn>
          </v-col>
        </v-row>
      </v-app-bar>
    </transition>

    <v-main class="main-content">
      <transition mode="out-in"><router-view v-if="isReady" :key="routeKey" /></transition>
    </v-main>
    <CursorComponent v-if="!$root.platform.mobile && !cursorHiddenInRoute" />
    <HoverDot v-if="!$root.platform.mobile" />
    <MainMenu v-model="menuOpen" v-if="isReady" />
    <VersionInfo
      v-if="$root.process.env.SERVICE_STAGE !== 'production'"
      :version="$root.process.env.GIT_VERSION"
      :commit-hash="$root.process.env.GIT_COMMIT_HASH"
      />
  </v-app>
</template>

<script>
import { VersionInfo, Viewport } from '@monogrid/vue-lib'
import { Platform } from '@monogrid/js-utils'
import CursorComponent from '@/atoms/Cursor'
import HoverDot from '@/atoms/HoverDot'
import MainMenu from '@/organisms/MainMenu'
import Logo from '@/assets/img/logo.svg'
// import HamburgerIcon from '@/assets/img/hamburger.svg'
// import CloseIcon from '@/assets/img/close.svg'
import GetSiteSettings from '@/graphql/GetSiteSettings.gql'
import Lottie from 'vue-lottie'
import HamburgerAnim from '@/assets/bodymovin/hamburger-x.json'
let initializedModernizr = false
const avifImage = 'data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUEAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAF0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgS0AAAAAABNjb2xybmNseAACAAIAAIAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAAGVtZGF0EgAKBzgAPtAgIAkyUBAAAPWc41TP///4gHBX9H8XVK7gGeDllq8TYARA+8Tfsv7L+zPE24eIoIzE0WhHbrqcrTK9VEgEG/hwgB5rdCbvP8g3KYPdV88CvPJnptgQ'

export default {
  name: 'App',
  mixins: [Viewport],
  components: {
    VersionInfo,
    CursorComponent,
    HoverDot,
    MainMenu,
    Logo,
    // HamburgerIcon,
    // CloseIcon,
    Lottie
  },

  async mounted () {
    this.$root.preloader.visible = true
  },

  apollo: {
    SiteSettings: {
      query: GetSiteSettings,
      variables () {
        return {
          slug: this.$language.current,
          status: 'PUBLISHED'
        }
      },
      result () {
        this.$root.siteSettings = this.SiteSettings
        this.isReady = true
        this.$root.soundManager.initialize({
          clickSound: `/media/${this.SiteSettings.siteClickSound.id}`,
          bgSound: `/media/${this.SiteSettings.siteBackgroundMusic.id}`
        })
      }
    }
  },
  updated () {
    // if not prerenderer
    if (!Platform.prerenderer && window.Modernizr && !initializedModernizr) {
      // add custom modernizr tests
      initializedModernizr = true
      this.testAvif()
      // window.Modernizr.addAsyncTest('avif', this.testAvif)
      for (const key in Platform) {
        window.Modernizr.addTest(key, () => {
          return Platform[key]
        })
      }
    }
  },
  data: function () {
    return {
      menuOpen: false,
      // this flag is used to show the app once the preloading
      // (if present) is finished
      isReady: false,
      // platform, accessible with an import statement
      // or by using this.$root.platform
      // NOTE: import statement is preferred
      platform: Platform,
      HamburgerAnim
    }
  },

  methods: {
    testAvif () {
      try {
        var image = new Image()
        image.onload = image.onerror = function () {
          window.Modernizr.addTest('avif', image.height === 2)
        }
        image.src = avifImage
      } catch (e) {
        window.Modernizr.addTest('avif', false)
      }
    },
    handleAnimation (anim) {
      this.hamburgerAnim = anim
      this.hamburgerAnim.stop()
    }
    // async registerServiceWorker () {
    //   if ('serviceWorker' in navigator) {
    //     try {
    //       await navigator.serviceWorker.register('/service-worker.js') // eslint-disable-line
    //     } catch (e) {
    //       console.warn('Service Worker Registration failed:', e.toString())
    //     }
    //   }
    // }
  },

  watch: {
    menuOpen (value) {
      if (value) {
        this.hamburgerAnim.playSegments([this.hamburgerAnim.currentFrame, 60], true)
      } else {
        this.hamburgerAnim.playSegments([this.hamburgerAnim.currentFrame, 0], true)
      }
    },
    isReady: function (value) {
      // hide / show preloader
      this.$root.preloader.visible = !value
    },
    dark (value) {
      this.$vuetify.theme.dark = value
    }
  },

  computed: {
    routeKey () {
      if (typeof this.$route.meta === 'function') {
        return this.$route.meta(this.$route).key || this.$route.name
      }

      return this.$route.name
    },
    cursorHiddenInRoute () {
      if (typeof this.$route.meta === 'function') {
        return this.$route.meta(this.$route).cursorHidden
      }
      return false
    },
    navigationDisabledInRoute () {
      if (typeof this.$route.meta === 'function') {
        return this.$route.meta(this.$route).navigationDisabled
      }
      return false
    },
    dark () {
      return this.$route.meta && this.$route.meta.dark && !this.menuOpen
    }
  },

  metaInfo: function () {
    const imageMeta = this.$root.siteSettings ? JSON.parse(this.$root.siteSettings.siteSocialShareImage.metaData) : {}
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: ' ',
      // all titles will be injected into this template
      titleTemplate: `%s | ${this.$root.siteSettings ? this.$root.siteSettings.siteTitle : ''}`,
      base: { href: '/' },
      htmlAttrs: {
        lang: this.$language.current
      },
      meta: [
        { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' },
        { name: 'apple-mobile-web-app-capable', content: 'yes' },
        { name: 'mobile-web-app-capable', content: 'yes' },
        // twitter
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:site', content: '@vogue_italia' },
        { name: 'twitter:creator', content: '@monogridstudio' },
        // generic description
        { vmid: 'description', name: 'description', content: this.$root.siteSettings ? this.$root.siteSettings.siteSocialDescription : '' },
        // og tags
        { vmid: 'ogtype', property: 'og:type', content: 'website' },
        { vmid: 'ogurl', property: 'og:url', content: 'https://' + this.$root.process.env.SERVICE_TARGET_DOMAIN + this.$route.fullPath },
        { vmid: 'ogtitle', property: 'og:title', itemprop: 'name', content: this.$root.siteSettings ? this.$root.siteSettings.siteTitle : '' },
        { vmid: 'ogdescription', property: 'og:description', content: this.$root.siteSettings ? this.$root.siteSettings.siteSocialDescription : '' },
        { vmid: 'ogimage', property: 'og:image', content: this.$root.siteSettings ? `https://${this.$root.process.env.SERVICE_TARGET_DOMAIN}/media/${this.$root.siteSettings.siteSocialShareImage.id}` : '' },
        { vmid: 'ogimagetype', property: 'og:image:type', content: this.$root.siteSettings ? this.$root.siteSettings.siteSocialShareImage.mimeType : 'image/jpeg' },
        { vmid: 'ogimageheight', property: 'og:image:width', content: imageMeta['image-width'] || '1200' },
        { vmid: 'ogimagewidth', property: 'og:image:height', content: imageMeta['image-height'] || '630' }
      ]
    }
  }
}
</script>

<style lang="scss">

@import url('https://fonts.googleapis.com/css2?family=Karla:ital,wght@0,400;0,700;1,400;1,700&display=swap');

@font-face {
  font-family: 'Didot HTF';
  src: url('./assets/fonts/DidotHTF-Bold.woff2') format('woff2'),
    url('./assets/fonts/DidotHTF-Bold.woff') format('woff');
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Domaine Sans Display';
  src: url('./assets/fonts/DomaineSansDisplay-Regular.woff2') format('woff2'),
    url('./assets/fonts/DomaineSansDisplay-Regular.woff') format('woff');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Tiempos Fine';
  src: url('./assets/fonts/TiemposHeadline-Light.woff2') format('woff2'),
    url('./assets/fonts/TiemposHeadline-Light.woff') format('woff');
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

h1,
.heading1 {
  font-family: map-get(map-get($headings, 'h1'), 'font-family');
  font-weight: map-get(map-get($headings, 'h1'), 'weight');
  letter-spacing: map-get(map-get($headings, 'h1'), 'letter-spacing');
  line-height: map-get(map-get($headings, 'h1'), 'line-height');
  font-size: map-get(map-get($headings, 'h1'), 'size');

  @include breakpoint('lg-and-down') {
    font-size: map-get(map-get($headings, 'h1'), 'size') - 0.3rem;
  }

  @include breakpoint('sm-and-down') {
    font-size: map-get(map-get($headings, 'h1'), 'size') - 1rem;
  }
}

h2,
.heading2 {
  font-family: map-get(map-get($headings, 'h2'), 'font-family');
  font-weight: map-get(map-get($headings, 'h2'), 'weight');
  letter-spacing: map-get(map-get($headings, 'h2'), 'letter-spacing');
  line-height: map-get(map-get($headings, 'h2'), 'line-height');
  font-size: map-get(map-get($headings, 'h2'), 'size');

  // @include breakpoint('sm-and-down') {
  //   font-size: map-get(map-get($headings, 'h2'), 'size');
  // }
}

h3,
.heading3 {
  font-family: map-get(map-get($headings, 'h3'), 'font-family');
  font-weight: map-get(map-get($headings, 'h3'), 'weight');
  letter-spacing: map-get(map-get($headings, 'h3'), 'letter-spacing');
  line-height: map-get(map-get($headings, 'h3'), 'line-height');
  font-size: map-get(map-get($headings, 'h3'), 'size');

  @include breakpoint('lg-and-down') {
    font-size: map-get(map-get($headings, 'h3'), 'size') - 0.5rem;
  }
  @include breakpoint('sm-and-down') {
    font-size: map-get(map-get($headings, 'h3'), 'size') - 1rem;
  }
}

h4,
.heading4 {
  font-family: map-get(map-get($headings, 'h4'), 'font-family');
  font-weight: map-get(map-get($headings, 'h4'), 'weight');
  letter-spacing: map-get(map-get($headings, 'h4'), 'letter-spacing');
  line-height: map-get(map-get($headings, 'h4'), 'line-height');
  font-size: map-get(map-get($headings, 'h4'), 'size');

  @include breakpoint('lg-and-down') {
    font-size: map-get(map-get($headings, 'h4'), 'size') - 0.4rem;
  }

  @include breakpoint('sm-and-down') {
    font-size: map-get(map-get($headings, 'h4'), 'size') - 0.6rem;
  }
}

h5,
.heading5 {
  font-family: map-get(map-get($headings, 'h5'), 'font-family');
  font-weight: map-get(map-get($headings, 'h5'), 'weight');
  letter-spacing: map-get(map-get($headings, 'h5'), 'letter-spacing');
  line-height: map-get(map-get($headings, 'h5'), 'line-height');
  font-size: map-get(map-get($headings, 'h5'), 'size');

  @include breakpoint('lg-and-down') {
    font-size: map-get(map-get($headings, 'h1'), 'size') - 0.4rem;
  }

  @include breakpoint('sm-and-down') {
    font-size: map-get(map-get($headings, 'h1'), 'size') - 0.6rem;
  }
}

// .pt-xl-200 {
//   @include breakpoint('xl-only') {
//     padding-top: 200px !important;
//   }
// }

// .pt-lg-100 {
//   @include breakpoint('lg-and-up') {
//     padding-top: 100px !important;
//   }
// }

.pt-200 {
  padding-top: 200px !important;

  @include breakpoint('lg-and-down') {
    padding-top: 80px !important;
  }

  @include breakpoint('sm-and-down') {
    padding-top: 40px !important;
  }

  // @include breakpoint('xs-only') {
  //   padding-top: 40px !important;
  // }
}

.v-toolbar__title {
  font-family: $heading-font-family;
  min-width: 200px;

  svg {
    width: 160px;
    height: 16px;

    @include breakpoint('sm-and-down') {
      width: 120px;
      height: 12px;
    }

    path,
    g {
      fill: map-get($shades, 'white') !important;

      // stylelint-disable-next-line
      .no-backgroundblendmode & {
        fill: map-get($shades, 'black') !important;

        // stylelint-disable-next-line
        .theme--dark & {
          fill: map-get($shades, 'white') !important;
        }
      }
    }
  }
}

// .v-dialog__content {
//   z-index: $z-dialogs !important;
// }

.theme--light.v-app-bar {
  background-color: transparent !important;
}

.theme--dark.v-app-bar {
  background-color: transparent !important;
}

.main-content {
  z-index: $z-content;
}

.v-app-bar {
  z-index: $z-header-footer !important;
  pointer-events: none;
  mix-blend-mode: difference;

  transition: all 0.25s $ease-in-out-quad, padding 1s $ease-out-quad !important;

  @include breakpoint('md-and-up') {
    padding-top: 25px;
    padding-left: 25px;
    padding-right: 25px;
  }

  button,
  a {
    pointer-events: all;
  }

  .menu-open & {
    @include breakpoint('md-and-up') {
      padding-top: 64px;
      padding-left: 64px;
      padding-right: 64px;
    }
  }

}

.v-application--wrap {
  min-height: inherit !important;
}

.v-navigation-drawer {
  z-index: $z-menu;
}

.hamburger {
  svg {
    color: #ffff;
    // max-width: 80%;
    // max-height: 80%;

    path {
      stroke: currentColor;
      stroke-width: 2px;

      // .theme--dark & { // stylelint-disable-line
      //   stroke: map-get($shades, 'white');
      // }
    }

    .no-backgroundblendmode & {
      path { // stylelint-disable-line
        stroke: map-get($shades, 'black');

        .theme--dark & { // stylelint-disable-line
          stroke: map-get($shades, 'white');
        }
      }
    }
  }
}

a {
  text-decoration: none;
  color: map-get($shades, 'black');

  &:visited,
  &:active,
  &:focus,
  &:hover {
    color: map-get($shades, 'black');
  }
}

// hide button backgrounds
.v-btn {
  &::before {
    // background-color: transparent !important;
    transform: scale3d(0, 1, 1);
    transform: scale3d(var(--progress, 0), 1, 1);
    transform-origin: 0 50%;
    // transition: transform 0.5s $ease-in-out-cubic;
    opacity: 1;
  }

  .v-btn__content {
    transform-origin: 50% 50%;
    transition: transform 0.25s $ease-in-out-cubic;

    svg {
      transition: color 0.25s $ease-in-out-cubic;
    }
  }

  &:hover {
    .v-btn__content {
      svg {
        color: rgba(map-get(map-get($material-light, 'text'), 'secondary'), 0.7);
      }
    }
  }
}

.theme--light.v-btn.v-btn--icon {
  color: map-get(map-get($material-light, 'text'), 'primary');
}

.theme--light.v-btn:hover::before {
  opacity: 1 !important;
}

.v-ripple__animation {
  opacity: 0 !important;
}

// generic transition for when <transition> tag is used
.v-enter-active,
.v-leave-active,
.standard-enter-active,
.standard-leave-active {
  .no-prerenderer & {
    transition: opacity 0.5s $ease-out-quad;
  }
}

.v-enter,
.v-leave-to,
.standard-enter,
.standard-leave-to {
  opacity: 0;
}

.from-below-enter-active,
.from-below-leave-active {
  .no-prerenderer & {
    // transition-duration: 0s;
    transition: opacity 0.5s $ease-out-quad, transform 1s $ease-out-quad;
    transition-delay: 0;
    transition-delay: var(--appear-delay);
  }

}

.from-below-enter,
.from-below-leave-to {
  opacity: 0;
  transform: translate3d(0, 30px, 0);
}

.text-nationality {
  font-size: 1.1rem;
}

.fixed-close-button {
  position: fixed;
  background-color: rgba($c-light-pink, 0.5);
}

.fill-height {
  height: 100%;
}

.shrink {
  flex-shrink: 1 !important;
  flex-grow: 0 !important;
}

.grow {
  flex-shrink: 0 !important;
  flex-grow: 1 !important;
}

.v-application .elevation-4 {
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2 * 0.5), 0 4px 5px 0 rgba(0, 0, 0, 0.14 * 0.5), 0 1px 10px 0 rgba(0, 0, 0, 0.12 * 0.5) !important;
}

@keyframes clouds-motion-1 {
  0% {
    opacity: 0;
    transform: translate3d(0, 0, 0);
  }

  1% {
    opacity: 1;
  }

  99% {
    transform: translate3d(50%, 0, 0);
    opacity: 1;
  }

  100% {
    opacity: 0;
    transform: translate3d(50%, 0, 0);
  }
}

@keyframes hero-title-motion {
  0% {
    transform: translate3d(-50vw, -50%, 0);
  }

  100% {
    transform: translate3d(-90vw, -50%, 0);
  }
}

.generic-image-link {
  .v-image {
    overflow: hidden;
    // z-index: -1;

    .v-image__image {
      transition: transform 0.3s $ease-in-out-quad;
    }
  }

  &:hover {
    .v-image__image {
      transform: scale3d(1.1, 1.1, 1.1);
    }
  }
}

.image-dark-cover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(#131313, 0.3);
}
</style>
